module.exports = __webpack_public_path__ + "static/media/l.244e77d3.svg";